export default "__VITE_ASSET__CL0R3h8r__"